import { render, staticRenderFns } from "./store-Info-chip.vue?vue&type=template&id=1b17482b&scoped=true"
import script from "./store-Info-chip.vue?vue&type=script&lang=js"
export * from "./store-Info-chip.vue?vue&type=script&lang=js"
import style0 from "./store-Info-chip.vue?vue&type=style&index=0&id=1b17482b&prod&lang=scss"
import style1 from "./store-Info-chip.vue?vue&type=style&index=1&id=1b17482b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b17482b",
  null
  
)

export default component.exports